export const LOGIN_ROOT = '/login'
export const APP_LAUNCHER = '/oauth/launch/:clientId'
